import { useDrawer } from '@cast/design-system';

import {
  ProvisionNodesDrawer,
  ProvisionNodesDrawerProps,
} from './ProvisionNodesDrawer';

export const useProvisionNodesDrawer = () => {
  const { open } = useDrawer();

  return {
    openProvisionNodesDrawer: (props: ProvisionNodesDrawerProps) =>
      open({ component: ProvisionNodesDrawer, props }),
  };
};
